import { formatCurrency } from '@servicetitan/financing-utils-shared';
import { FinancedAmountStore } from './financedAmountStore';
import { Flex, Text } from '@servicetitan/anvil2';
import { ProviderAndLogo } from './ProviderAndLogo';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';

interface DisplayProps {
    showProviderSelection?: boolean;
}

export const Display = ({ showProviderSelection }: DisplayProps) => {
    const { financedAmount } = FinancedAmountStore.useStore();
    const { setupData } = SetupDataStore.useStore();

    return (
        <Flex direction="column" gap="4">
            {showProviderSelection && (
                <Text variant="headline" el="h2" style={{ margin: 0 }}>
                    Financing Information
                </Text>
            )}
            <Flex direction="column" gap="4" sm={{ direction: 'row' }}>
                {showProviderSelection && (
                    <div style={{ minWidth: '224px' }}>
                        <Text variant="eyebrow">Provider</Text>
                        <Flex direction="row" gap="2" alignItems="center">
                            <ProviderAndLogo provider={setupData?.provider} />
                        </Flex>
                    </div>
                )}
                <div>
                    <Text variant="eyebrow" id="desired-financed-amount-label">
                        Desired Financed Amount
                    </Text>
                    <Text aria-labelledby="desired-financed-amount-label">
                        {formatCurrency(financedAmount!)}
                    </Text>
                </div>
            </Flex>
        </Flex>
    );
};
